import Vue from 'vue';
import Router from 'vue-router';
// 登錄
import login from '../pages/login/login.vue';
// 主頁
import index from '../components/Index.vue';
import home from '../pages/home/home.vue';
// 活動
import activityList from '../pages/activity/activityList.vue';
import addActivity from '../pages/activity/addActivity.vue';
import editActivity from '../pages/activity/editActivity.vue';
import editStatus from '../pages/activity/editStatus.vue';
import activityDrawFirst from '../pages/activity/activityDrawFirst.vue'
import activityDrawList from '../pages/activity/activityDrawList.vue'
import activityDrawConfirmList from '../pages/activity/activityDrawConfirmList.vue'
import activityDrawDetail from '../pages/activity/activityDrawDetail.vue'
import draftActivityList from '../pages/activity/draftActivityList.vue'
// 行事曆
import calendarList from '../pages/activity/calendarList.vue';
import addCalendar from '../pages/activity/addCalendar.vue';
import editCalendar from '../pages/activity/editCalendar.vue';
// 新聞--jj日記
import JJdiary from '../pages/news/JJdiary/JJdiary.vue';
import addDiary from '../pages/news/JJdiary/addDiary.vue';
import editDiary from '../pages/news/JJdiary/editDiary.vue';
// 新聞-新聞列表
import newsList from '../pages/news/news/newsList.vue';
import viewComment from '../pages/news/news/viewComment.vue';
import editNews from '../pages/news/news/editNews.vue';
import addNews from '../pages/news/news/addNews.vue';
import draftNews from '../pages/news/news/draftNews.vue';
// 新聞--vlog
import newsVlog from '../pages/news/vlog/newsVlog';
import addVlog from '../pages/news/vlog/addVlog.vue';
import editVlog from '../pages/news/vlog/editVlog.vue';
// 新聞--生日影片
import birthdayVideoList from '../pages/news/birthdayVideo/birthdayVideoList.vue';
import addBirthVideo from '../pages/news/birthdayVideo/addBirthVideo.vue';
import editBirthVideo from '../pages/news/birthdayVideo/editBirthVideo.vue';
// 私密相簿
import photoPrivacy from '../pages/news/photoPrivacy/photoList.vue';
import addPhoto from '../pages/news/photoPrivacy/addPhoto.vue';
import editPhoto from '../pages/news/photoPrivacy/editPhoto.vue';
// 評論投訴
import commentComplaint from '../pages/news/commentComplaint/commentComplaintList.vue';
// 評論管理
import comments from "../pages/news/comments/comments.vue";
// banner管理
import marketBannerList from '../pages/banner/marketBanner/marketBannerList.vue';
import addMarketBanner from '../pages/banner/marketBanner/addMarketBanner.vue';
import editMarketBanner from '../pages/banner/marketBanner/editMarketBanner.vue';

// 商城商品
import goodsList from '../pages/market/marketGoods/goodsList.vue';
import editorialInventory from '../pages/market/marketGoods/editorialInventory.vue';
import addGoods from '../pages/market/marketGoods/addGoods.vue';
import editGoods from '../pages/market/marketGoods/editGoods.vue';
import draftGoods from '../pages/market/marketGoods/draftGoods'
import goodsPreview from "../pages/market/marketGoods/goodsPreview";
// 會員商品
import memberGoodsList from '../pages/market/memberGoods/memberGoodsList.vue';
import addMemberGoods from '../pages/market/memberGoods/addMemberGoods.vue';
import editMemberGoods from '../pages/market/memberGoods/editMemberGoods.vue';

// 版本管理
import versionUpdate from '../pages/version/versionUpdate.vue';
import editVersion from '../pages/version/editVersion.vue';
//版本更新介绍
import updateIntList from '../pages/version/updateIntList.vue';
import addIntroduction from '../pages/version/addIntroduction.vue';
import editIntroduction from '../pages/version/editIntroduction.vue';

// 會員-會員列表
import userInfo from '../pages/user/userInfo.vue';
import userDetails from '../pages/user/userDetails.vue';
import badgeManager from "../pages/user/badgeManager";
// 會員-實名認證
import certificationList from '../pages/user/certificationList.vue';
import authDetails from '../pages/user/authDetails.vue';
// 會員-黑名單列表
import blackList from '../pages/user/blackList.vue';
import blackListDetails from '../pages/user/blackListDetails.vue';
// 會員-用戶數據
import userData from '../pages/user/userData.vue';
// 會員-意見反饋
import feedback from '../pages/user/feedback.vue';
import questionList from '../pages/user/questionList.vue';
// 專輯
import specialEditionList from '../pages/specialEdition/specialEditionList.vue'
import addSpecialEdition from '../pages/specialEdition/addSpecialEdition.vue'
import editSpecialEdition from '../pages/specialEdition/editSpecialEdition.vue'
// 訂單列表
import orderDetails from '../pages/order/allOrder/orderDetails.vue'; //訂單詳情
// import orderDetailsold from '../pages/order/allOrder/orderDetailsold.vue'; //訂單詳情
import moneyOrder from '../pages/order/allOrder/moneyOrder.vue'; // 所有訂單
import afterSalesList from '../pages/order/allOrder/afterSalesList.vue'; // 所有訂單
// import moneyOrderold from '../pages/order/allOrder/moneyOrderold.vue'; // 所有訂單
import memberOrderList from '../pages/order/member/memberOrderList.vue';
import afterSalesDetails from '../pages/order/allOrder/afterSalesDetails.vue';
import marketOrderList from '../pages/order/market/marketOrderList.vue';
import outOrderDetails from '../pages/order/outOrderDetails.vue'; // 出貨訂單詳情
import gashaponList from '../pages/order/gashapon/gashaponList.vue'; // 扭蛋訂單列表
import wrongOrder from '../pages/order/wrongOrder/wrongOrder.vue'; //問題訂單
//直播
import liveList from '../pages/live/liveList.vue';
import liveComment from '../pages/live/liveComment.vue';
//相关问题
import replyQuestionList from '../pages/question/questionList.vue';
import questionDetails from '../pages/question/questionDetails.vue';
//签到
import signList from '../pages/sign/signList.vue'; //签到列表
import signDetail from '../pages/sign/signDetail.vue'; //签到列表
import commentList from '../pages/sign/commentList.vue'; //签到列表
//社區
import subjectList from '../pages/community/subjectList.vue'; //話題列表
import postList from '../pages/community/postList.vue'; //帖子列表
import complaintList from '../pages/community/complaintList.vue'; //投訴列表
import addSubject from '../pages/community/addSubject.vue'; //新增話題
import editSubject from '../pages/community/editSubject.vue'; //編輯話題
import postCommentList from '../pages/community/postCommentList.vue'; //帖子评论列表
import postDetails from '../pages/community/postDetails.vue'; //帖子詳情
// import complaintDetails from '../pages/community/complaintDetails.vue';//投訴詳情
import complaintReason from '../pages/community/complainReason.vue'; //投訴原因
import editBillBoard from '../pages/community/editBillBoard.vue'; //編輯公告
// 個人設置
import accountSetting from '../pages/setting/accountSetting.vue'; //帳號設置
import alterPasswords from '../pages/setting/alterPasswords.vue'; //修改密碼
import city from '../pages/city/city.vue';
import cityList from '../pages/city/cityList.vue';
import checkActivity from '../pages/checkActivity/activityList.vue';
import checkList from '../pages/checkActivity/checkList.vue';
import mangerList from '../pages/checkActivity/mangerList.vue';
import addcheckActivity from '../pages/checkActivity/addActivity.vue';
//回信
import letterList from '../pages/letter/letterList.vue';
import replayList from '../pages/letter/replayList.vue';
//灵魂的共鸣
import collectionList from '../pages/jjsoul/collectionList.vue';
import collectionDetail from '../pages/jjsoul/collectionDetail.vue';
import addCollection from '../pages/jjsoul/addCollection.vue';
import collectionComments from '../pages/jjsoul/comments.vue';
import collectionComplain from '../pages/jjsoul/collectionComplain.vue';
import collectionComment from '../pages/jjsoul/collectionComment.vue';
// 賬號檢舉
import reportList from '../pages/user/account/reportList.vue';
Vue.use(Router);


const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
      component: login
    },
    {
      path: '/login', name: 'login', component: login
    },
    {
      path: '/', name: 'index', component: index, children: [
        {
          path: '/home', name: 'home', component: home
        },
        {
          path: '/activityList', name: 'activityList', component: activityList
          , meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/addActivity', name: 'addActivity', component: addActivity
        },
        {
          path: '/editStatus', name: 'editStatus', component: editStatus
        },
        {
          path: '/editActivity', name: 'editActivity', component: editActivity
        },
        {
          path: '/activityDrawFirst', name: 'activityDrawFirst', component: activityDrawFirst
        },
        {
          path: '/activityDrawList', name: 'activityDrawList', component: activityDrawList,
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/activityDrawConfirmList', name: 'activityDrawConfirmList', component: activityDrawConfirmList,
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/activityDrawDetail', name: 'activityDrawDetail', component: activityDrawDetail
        },
        {
          path: '/draftActivityList', name: 'draftActivityList', component: draftActivityList
        },
        {
          path: '/JJdiary', name: 'JJdiary', component: JJdiary
        },
        {
          path: '/addDiary', name: 'addDiary', component: addDiary
        },
        {
          path: '/editDiary', name: 'editDiary', component: editDiary
        },
        {
          path: '/newsList', name: 'newsList', component: newsList,
          title: '新聞列表',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/viewComment', name: 'viewComment', component: viewComment
        },
        {
          path: '/addNews', name: 'addNews', component: addNews
        },
        {
          path: '/draftNews', name: 'draftNews', component: draftNews
        },
        {
          path: '/editNews', name: 'editNews', component: editNews
        },
        {
          path: '/newsVlog', name: 'newsVlog', component: newsVlog,
          title: 'vlog',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/addVlog', name: 'addVlog', component: addVlog
        },
        {
          path: '/editVlog', name: 'editVlog', component: editVlog
        },
        {
          path: '/birthdayVideoList', name: 'birthdayVideoList', component: birthdayVideoList
        },
        {
          path: '/addBirthVideo', name: 'addBirthVideo', component: addBirthVideo
        },
        {
          path: '/editBirthVideo', name: 'editBirthVideo', component: editBirthVideo
        },
        {
          path: '/photoPrivacy', name: 'photoPrivacy', component: photoPrivacy,
          title: 'photoPrivacy',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/addPhoto', name: 'addPhoto', component: addPhoto
        },
        {
          path: '/editPhoto', name: 'editPhoto', component: editPhoto
        },
        {
          path: '/commentComplaint', name: 'commentComplaint', component: commentComplaint,
          title: 'commentComplaint',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        }, {
          path: '/comments', name: 'comments', component: comments,
          title: 'comments',
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/marketBannerList', name: 'marketBannerList', component: marketBannerList,
          title: 'marketBannerList',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/editMarketBanner', name: 'editMarketBanner', component: editMarketBanner
        },
        {
          path: '/addMarketBanner', name: 'addMarketBanner', component: addMarketBanner
        },
        {
          path: '/goodsList', name: 'goodsList', component: goodsList,
          title: 'goodsList',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/addGoods', name: 'addGoods', component: addGoods
        },
        {
          path: '/editGoods', name: 'editGoods', component: editGoods
        },
        {
          path: '/draftGoods', name: 'draftGoods', component: draftGoods
        },
        {
          path: '/goodsPreview', name: 'goodsPreview', component: goodsPreview
        },
        {
          path: '/editorialInventory', name: 'editorialInventory', component: editorialInventory
        },
        {
          path: '/memberGoodsList', name: 'memberGoodsList', component: memberGoodsList,
          title: 'memberGoodsList',
          meta: {
            keepAlive: true,//此組件需要緩存
          }
        },
        {
          path: '/addMemberGoods', name: 'addMemberGoods', component: addMemberGoods
        },
        {
          path: '/editMemberGoods', name: 'editMemberGoods', component: editMemberGoods
        },
        {
          path: '/calendarList', name: 'calendarList', component: calendarList,
          title: '行事曆列表',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/addCalendar', name: 'addCalendar', component: addCalendar
        },
        {
          path: '/editCalendar', name: 'editCalendar', component: editCalendar
        },
        {
          path: '/versionUpdate', name: 'versionUpdate', component: versionUpdate
        },
        {
          path: '/editVersion', name: 'editVersion', component: editVersion
        },
        {
          path: '/updateIntList', name: 'updateIntList', component: updateIntList,
          title: 'updateIntList',
          meta: {
            keepAlive: true,//此組件需要緩存
          }
        },
        {
          path: '/addIntroduction', name: 'addIntroduction', component: addIntroduction
        },
        {
          path: '/editIntroduction', name: 'editIntroduction', component: editIntroduction
        },
        {
          path: '/userInfo',
          name: 'userInfo',
          component: userInfo,
          title: '用戶列表',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: '/userDetails', name: 'userDetails', component: userDetails
        },
        {
          path: '/badgeManager', name: 'badgeManager', component: badgeManager
        },
        {
          path: 'moneyOrder',
          name: 'moneyOrder',
          component: moneyOrder,
          title: '會員訂單',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: 'certificationList',
          name: 'certificationList',
          component: certificationList,
          title: '實名認證',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: 'authDetails',
          name: 'authDetails',
          component: authDetails,
          title: '實名詳情',
        },
        {
          path: 'orderDetails', name: 'orderDetails', component: orderDetails
        },
        {
          path: 'blackList', name: 'blackList', component: blackList,
          title: '黑名單列表',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: 'blackListDetails', name: 'blackListDetails', component: blackListDetails
        },
        {
          path: 'userData', name: 'userData', component: userData
        },
        {
          path: 'feedback', name: 'feedback', component: feedback
        },
        {
          path: 'questionList', name: 'questionList', component: questionList
        },
        {
          path: 'specialEditionList', name: 'specialEditionList', component: specialEditionList,
          title: '專輯列表',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: 'addSpecialEdition', name: 'addSpecialEdition', component: addSpecialEdition
        },
        {
          path: 'editSpecialEdition', name: 'editSpecialEdition', component: editSpecialEdition
        },
        {
          path: 'afterSalesDetails', name: 'afterSalesDetails', component: afterSalesDetails
        },
        {
          path: 'memberOrderList', name: 'memberOrderList', component: memberOrderList,
          title: '出貨订单',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: 'afterSalesList', name: 'afterSalesList', component: afterSalesList,
          title: '售后订单',
          meta: {
            keepAlive: true, //此組件需要緩存
          }
        },
        {
          path: 'replyQuestionList', name: 'replyQuestionList', component: replyQuestionList,
          title: '售后订单',
        },
        {
          path: 'questionDetails', name: 'questionDetails', component: questionDetails
        },
        {
          path: 'outOrderDetails', name: 'outOrderDetails', component: outOrderDetails
        },
        // {
        //   path: 'marketOrderList', name: 'marketOrderList', component: marketOrderList,
        //   title: '商城出貨',
        //   meta: {
        //     keepAlive: true, //此組件需要緩存
        //   }
        // },
        // {
        //   path: 'gashaponList', name: 'gashaponList', component: gashaponList,
        //   title: '扭蛋出貨',
        //   meta: {
        //     keepAlive: true
        //   }
        // },
        {
          path: 'wrongOrder', name: 'wrongOrder', component: wrongOrder,
          title: '問題訂單',
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'liveList', name: 'liveList', component: liveList,
          title: '直播管理',
        },
        {
          path: 'liveComment', name: 'liveComment', component: liveComment,
        },
        {
          path: 'signList', name: 'signList', component: signList,
        },
        {
          path: 'signDetail', name: 'signDetail', component: signDetail,
        },
        {
          path: 'commentList', name: 'commentList', component: commentList,
        },
        {
          path: 'subjectList', name: 'subjectList', component: subjectList,
          title: '話題列表',
          meta: {
            keepAlive: true,
          }
        },
        {
          path: 'postList', name: 'postList', component: postList,
          title: '帖子列表',
          meta: {
            keepAlive: true,
          }
        },
        {
          path: 'complaintList', name: 'complaintList', component: complaintList,
          title: '投訴列表',
          meta: {
            keepAlive: true,
          }
        },
        {
          path: 'addSubject', name: 'addSubject', component: addSubject
        },
        {
          path: 'editSubject', name: 'editSubject', component: editSubject
        },
        {
          path: 'postCommentList', name: 'postCommentList', component: postCommentList
        },
        {
          path: 'postDetails', name: 'postDetails', component: postDetails
        },
        {
          path: 'complaintReason', name: 'complaintReason', component: complaintReason
        },
        {
          path: 'editBillBoard', name: 'editBillBoard', component: editBillBoard,
        },
        {
          path: 'accountSetting', name: 'accountSetting', component: accountSetting,
        },
        {
          path: 'alterPasswords', name: 'alterPasswords', component: alterPasswords,
        }, {
          path: 'city', name: 'city', component: city,
        }, {
          path: 'cityList', name: 'cityList', component: cityList,
        },
        {
          path: 'checkActivity', name: 'checkActivity', component: checkActivity,
        },
        {
          path: 'checkList', name: 'checkList', component: checkList,
        },
        {
          path: 'mangerList', name: 'mangerList', component: mangerList,
        },
        {
          path: 'addcheckActivity', name: 'addcheckActivity', component: addcheckActivity,
        },
        {
          path: 'letterList', name: 'letterList', component: letterList, meta: {
          }
        },
        {
          path: 'replayList', name: 'replayList', component: replayList,
        },
        {
          path: 'collectionList', name: 'collectionList', component: collectionList,
        },
        {
          path: 'collectionDetail', name: 'collectionDetail', component: collectionDetail,
        },
        {
          path: 'addCollection', name: 'addCollection', component: addCollection,
        },
        {
          path: 'collectionComments', name: 'collectionComments', component: collectionComments,
        },
        {
          path: 'collectionComplain', name: 'collectionComplain', component: collectionComplain,
        },
        {
          path: 'collectionComment', name: 'collectionComment', component: collectionComment,
        },
        {
          path: '/reportList', name: 'reportList', component: reportList,
          title: '賬號檢舉',
          meta: {
            keepAlive: true,//此組件需要緩存
          }
        },
      ]
    },
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js